import React from 'react';
import { TableRow, Typography } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import PropTypes from 'prop-types';
import {
  formatNegativeAmount,
  formatPositiveAmount
} from 'src/utils/formatAmout';
import { Link } from 'react-router-dom';
import { capitalizeName, roundNumberToDecimals } from 'src/utils/common';
import { RentResumeBalanceType } from 'src/utils/constants/accounting';
import OverflowTipography from 'src/components/OverflowTipography';
import selectFormatDate from 'src/utils/selectDateFormat';
import dateFormatType from 'src/utils/dateFormatType';
import { useTranslation } from 'react-i18next';
import ReportBureauPaymentStatus from '../BuroReportDetail/PaymentStatusChip';

const RentResumeRow = ({
  initialBalance,
  rent,
  capitalContribution,
  residual,
  surcharge,
  discount,
  payment,
  finalBalance,
  clientFullname,
  clientId,
  initialPayment,
  contractId,
  balanceType,
  folio,
  paymentStatus,
  firstOverdueInvoiceDate,
  pendingInvoicesCount
}) => {
  const { t } = useTranslation();
  return (
    <TableRow hover>
      {balanceType === RentResumeBalanceType.CONTRACT && (
        <TableCell align="center">
          <Link to={`/contracts/${contractId}`}>
            <Typography
              sx={{
                fontFamily: 'Roboto',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '1.43'
              }}
              maxWidth="150px"
            >
              {folio}
            </Typography>
          </Link>
        </TableCell>
      )}
      <TableCell>
        <Link to={`/clients/detail/${clientId}`}>
          <OverflowTipography maxWidth="250px">
            {capitalizeName(clientFullname)}
          </OverflowTipography>
        </Link>
      </TableCell>
      <TableCell align="center">
        {formatPositiveAmount(roundNumberToDecimals(initialBalance))}
      </TableCell>
      <TableCell align="center">
        {formatPositiveAmount(roundNumberToDecimals(initialPayment))}
      </TableCell>
      <TableCell align="center">
        {formatPositiveAmount(roundNumberToDecimals(rent))}
      </TableCell>
      <TableCell align="center">
        {formatPositiveAmount(roundNumberToDecimals(capitalContribution))}
      </TableCell>
      <TableCell align="center">
        {formatPositiveAmount(roundNumberToDecimals(residual))}
      </TableCell>
      <TableCell align="center">
        {formatPositiveAmount(roundNumberToDecimals(surcharge))}
      </TableCell>
      <TableCell align="center">
        {formatNegativeAmount(roundNumberToDecimals(discount))}
      </TableCell>
      <TableCell align="center">
        {formatNegativeAmount(roundNumberToDecimals(payment))}
      </TableCell>
      <TableCell align="center">
        {formatPositiveAmount(roundNumberToDecimals(finalBalance))}
      </TableCell>
      {balanceType === RentResumeBalanceType.CONTRACT && (
        <>
          <TableCell align="center">
            {firstOverdueInvoiceDate
              ? selectFormatDate(firstOverdueInvoiceDate, dateFormatType.DAY)
              : t('COMMON.NO_DATA')}
          </TableCell>
          <TableCell align="center">{pendingInvoicesCount || 0}</TableCell>
          <TableCell align="center">
            <ReportBureauPaymentStatus paymentStatus={paymentStatus} />
          </TableCell>
        </>
      )}
    </TableRow>
  );
};

RentResumeRow.propTypes = {
  initialBalance: PropTypes.number,
  rent: PropTypes.number,
  capitalContribution: PropTypes.number,
  residual: PropTypes.number,
  surcharge: PropTypes.number,
  discount: PropTypes.number,
  payment: PropTypes.number,
  finalBalance: PropTypes.number,
  clientFullname: PropTypes.string,
  clientId: PropTypes.number,
  initialPayment: PropTypes.number,
  contractId: PropTypes.number,
  balanceType: PropTypes.string,
  folio: PropTypes.string,
  paymentStatus: PropTypes.string,
  firstOverdueInvoiceDate: PropTypes.string,
  pendingInvoicesCount: PropTypes.number
};

export default RentResumeRow;
